export const pluralizeText = (n, text_forms) => {
  n = Math.abs(n) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) {
    return text_forms[2];
  }
  if (n1 > 1 && n1 < 5) {
    return text_forms[1];
  }
  if (n1 == 1) {
    return text_forms[0];
  }
  return text_forms[2];
};

const VIN_FORMAT_REGEX = /^(?<wmi>[0-9A-HJ-NPR-Z]{3})(?<vds>[0-9A-HJ-NPR-Z]{6})(?<vis>[0-9A-HJ-NPR-Z]{8})$/;
const VIN_LAST_FOUR_DIGITS_REGEX = /^\d{4}$/;

export const validateVin = (vin) => {
  const normalizedVin = vin.toUpperCase();

  if (!VIN_FORMAT_REGEX.test(normalizedVin)) {
    return false;
  }

  return VIN_LAST_FOUR_DIGITS_REGEX.test(normalizedVin.slice(-4));
};

export const isEmail = (email) =>
  email.match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);

export const isServer = typeof window === "undefined";
